import React, { useState } from "react";
import cardImg from "../CardsStatusSection/assets/img.png";
import cardImg1 from "../CardsStatusSection/assets/1.png";
import cardImgIcon from "../CardsStatusSection/assets/drop.png";
import NftDetailsPopup from "../../../GlobalComponents/NftDetailsPopup/NftDetailsPopup";
import RaiseModal from "../../../GlobalComponents/RaiseModal/RaiseModal";
import Popup from "reactjs-popup";
const Card = ({ status, access, participants, block, amount, percent }) => {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <h2 className="text-center mb-[24px] leading-[24px] text-[28px] font-semibold">
        {status}
      </h2>
      <div className="bg-main-black rounded-[10px]">
        <div className="pt-[18px] px-[13px]  flex justify-center ">
          <div className="relative w-full">
            <img className="w-full" src={cardImg1} alt="" />
            <div className="absolute  flex justify-center items-center  bottom-0 rounded-b-[10px] w-full h-[30px] bg-main-green">
              <h2 className="text-[#0E0E0E] text-[18px] leading-[21px] font-semibold">
                Drip Network
              </h2>
            </div>
            <div className="absolute bottom-[8px] left-[17px]">
              <img src={cardImgIcon} alt="" />
            </div>
          </div>
        </div>
        <div className="mt-[17px] pl-[33px] pr-[35px]">
          <ul>
            <li className="flex justify-between text-res-xs font-semibold mb-[10px]">
              <h6>Access Tier</h6>
              <p className="text-bright-green">{access}</p>
            </li>
            <li className="flex justify-between text-xs font-semibold mb-[10px]">
              <h6>Participants</h6>
              <p className="text-bright-green">{participants}</p>
            </li>
            <li className="flex justify-between text-xs font-semibold mb-[10px]">
              <h6>Blockchain</h6>
              <p className="text-bright-green">{block}</p>
            </li>
            <li className="flex justify-between text-xs font-semibold mb-[20px]">
              <h6>Raise Date</h6>
              <p className="text-bright-green lowercase">{status}</p>
            </li>
          </ul>
          <div className="pb-[23px]">
            <h4 className="text-res-xs font-semibold mb-[5px]">
              Raised Amount
            </h4>
            <p className="text-res-xs font-semibold mb-[9px] ">
              <span className="text-bright-green ">{amount}</span> / 50,000 BNB
            </p>
            <div className="mb-[19px] h-[9px] relative max-w-100 rounded-full overflow-hidden">
              <div className="w-full h-full bg-light-black absolute"></div>
              <div
                id="bar"
                className="h-full bg-bright-green relative "
                style={{ width: percent }}
              ></div>
            </div>
            <button
              onClick={() => setOpen(true)}
              className="bg-bright-green  w-[128px] h-[29px] flex justify-center items-center p-[8px] rounded-[5px]"
            >
              <span className=" font-bold text-[15px] leading-[18px] text-light-black">
                View Details
              </span>
            </button>
          </div>
        </div>
      </div>
        <Popup open={open} position="right center">
          <div className="modalOverlay"></div>
          <RaiseModal
            thum={cardImg}
            open={open}
            setOpen={setOpen}
            profile="Drip Network"
            access={access}
            participants={participants}
            block={block}
            status={status}
            raisedAmountMax="50000"
            raisedAmountMin={amount}
            title="Drip Network"
          ></RaiseModal>
        </Popup>
      {/* {open && <NftDetailsPopup setOpen={setOpen}></NftDetailsPopup>} */}
    </div>
  );
};

export default Card;
